import { ObjectFieldTemplateProps } from "@rjsf/utils";
import { formatSchemaName } from '@/shared/utils/formatSchemaName';

export const ObjectFieldTemplate = (props: ObjectFieldTemplateProps) => {
  const entryNumber = props.title.match(/\d+$/);
  const titleString = entryNumber ? `Entry ${entryNumber[0]}` : formatSchemaName(props.title);
  const title = <h3>{titleString}</h3>;

  // Top-level sections have a $id like "root_Subjects". Tag them with data-section-key
  // so callers (e.g. CoReviewPage sidebar) can scroll to them. RJSF v6 exposes this
  // as `fieldPathId`; v5 used `idSchema` — read both for safety.
  const p = props as {
    fieldPathId?: { $id?: string };
    idSchema?: { $id?: string };
  };
  const id = p.fieldPathId?.$id ?? p.idSchema?.$id ?? "";
  const topLevelMatch = /^root_([A-Za-z0-9]+)$/.exec(id);
  const sectionKey = topLevelMatch ? topLevelMatch[1] : undefined;

  return (
    <div data-section-key={sectionKey}>
      {title}
      {props.description}
      {props.properties.map((element) => (
        <div className="property-wrapper">{element.content}</div>
      ))}
    </div>
  );
};
